import { render, staticRenderFns } from "./studentCreditcard.vue?vue&type=template&id=5482b598&"
import script from "./studentCreditcard.vue?vue&type=script&lang=ts&"
export * from "./studentCreditcard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports